import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import Step from "../components/Step";
import TranslatedFormGroup from "../components/FormGroup";
import { INPUT_NAMES } from "../utils/config";
import { isValid } from "../utils/validation";

const EmailStep = ({
	t,
	label,
	changeHandler,
	submitHandler,
	inputs,
	errors,
	processing,
	errMsg,
}) => (
	<form className="d-flex flex-column" onSubmit={submitHandler} noValidate>
		<p className="h5 mb-3">{t("emailTitle")}</p>
		<TranslatedFormGroup
			valid={isValid(errors[INPUT_NAMES.email])}
			feedback={errors[INPUT_NAMES.email]}
			label={label}
		>
			<input
				onChange={changeHandler}
				className="form-control"
				type="email"
				name={INPUT_NAMES.email}
				value={inputs[INPUT_NAMES.email]}
				maxLength="255"
				autoFocus
				required
			/>
		</TranslatedFormGroup>
		{errMsg && <div className="alert alert-danger">{errMsg}</div>}
		<button
			className="my-4 btn btn-primary btn-block btn-lg"
			type="submit"
			disabled={processing}
		>
			{t("labels.getStarted")}
		</button>
	</form>
);

EmailStep.propTypes = {
	t: PropTypes.func,
	label: PropTypes.string,
	inputs: PropTypes.object,
	errors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	changeHandler: PropTypes.func,
	submitHandler: PropTypes.func,
	processing: PropTypes.bool,
	errMsg: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

EmailStep.defaultProps = {
	label: "labels.email",
};

export default translate()(Step(EmailStep, { [INPUT_NAMES.email]: "" }));
